export class Hotel {
    hotel_id : number
    hotel_kategorie : string
        
    constructor(){
        this.hotel_id=0
        this.hotel_kategorie=''
    }
}